module.exports = __webpack_public_path__ + "img/rave box max.f27b6317.jpg";